import { Injectable } from '@angular/core';
import botd from "@fingerprintjs/botd";

let loadedBotd: ReturnType<typeof botd.load> | undefined;

@Injectable({
  providedIn: 'root'
})
export class BotDetectionService {
 public async isBot(): Promise<boolean> {
   if (!loadedBotd) {
     loadedBotd = botd.load();
   }

   const awaitedBotd = await loadedBotd;

   const result = awaitedBotd.detect();
   return result.bot;
 }
}
